<template>
  <div class="orders orders--multiple">
    <div class="close-cross" @click="cancelOrder"></div>

    <h2 v-html="footer.aLook"></h2>

    <h3>{{footer.groups}}</h3>

    <div class="block-container">
      <div class="orders__top-block">

        <div class="orders__left-block">

          <div class="tags select-products">
            <template v-for="tag in tags.tags">
              <a
                class="tag"
                :class="[selectedTag == tag.toLowerCase() ? 'selected' : '']"
                @click="tagClicked(tag)"
                v-if="tag !== 'view all' && tag !== 'article' && tag !== 'skatīt visus' && tag !== 'raksts'">
                {{tag.toUpperCase()}}
                <span class="tag__indicator"></span>
              </a>
              <div class="select-products__product"
                v-for="product in visibleProducts"
                v-if="compareTags(product.tags, tag) && tag !== 'view all' && tag !== 'article'">
                <input
                :id="product.id"
                class="product__select"
                type="checkbox"
                :value="product.id"
                v-model="selectedProducts"/>
                <label :for="product.id" v-html="product.title"></label>
              </div>
            </template>
          </div>
        </div>

        <!-- <div class="orders__right-block">

          <div class="">

            <div class="select-products__product" v-for="product in visibleProducts">
              <input
                :id="product.id"
                class="product__select"
                type="checkbox"
                :value="product.id"
                v-model="selectedProducts"/>
              <label :for="product.id">{{ product.title }}</label>
            </div>
          </div>
        </div>-->

      </div>

      <div class="orders__bottom-block">

        <div class="inputs">

          <div class="left-block block--even">

            <input class="user-data" id="name_surname" type="text" name="name_surname" v-bind:placeholder="footer.placeHolders[0]" required v-model="nameSurname"/>
            <input class="user-data" id="company" type="text" name="company" v-bind:placeholder="footer.placeHolders[1]" v-model="company"/>
            <input class="user-data" id="email" type="email" name="email" v-bind:placeholder="footer.placeHolders[2]" v-model="mail"/>

          </div>

          <div class="right-block block--even">
            <div class="checkboxes">
              <div class="personal-commercial-holder">
                <div class="personal">
                  <input id="pi" class="personal__input" type="checkbox" v-model="personal"/>
                  <label for="pi">{{footer.tickBoxes[0]}}</label>
                </div>

                <div class="commercial">
                  <input id="ci" class="commercial__input" type="checkbox" v-model="commercial"/>
                  <label for="ci">{{footer.tickBoxes[1]}}</label>
                </div>
              </div>

              <div class="gdpr">
                <input id="gi" class="gdpr__input" type="checkbox"/>
                <label for="gi">{{footer.tickBoxes[2]}}</label>
              </div>
            </div>
            <button name="TryButton" @click="sendOrder" class="button button--try button--rounded">{{texts.order}}</button>

          </div>
        </div>


      </div>
    </div>

  </div>
</template>

<script>

export default {
  name: 'MultipleOrders',
  data() {
    return {
      selectedTag: '',
      selectedProducts: [],
      nameSurname: '',
      company: '',
      mail: '',
      personal: false,
      commercial: false,
    }
  },
  props: {
    prod: Array,
  },
  computed: {
    state() {
      return this.$root.$data.state;
    },
    tags() {
      return this.state.tags;
    },
    texts() {
      return this.state.system.main;
    },
    footer() {
      return this.state.system.footer;
    },
    organizedData() {
      return {
        name: this.nameSurname,
        company: this.company,
        mail: this.mail,
        selectedProducts: this.selectedProducts,
        personal: this.personal,
        commercial: this.commercial,
      }
    },
    // selectedProducts: {
    //   get: function() {
    //     return this.$root.$data.state.selectedProducts;
    //   },
    //   set: function(newVal) {
    //     this.$root.$data.state.selectedProducts = newVal;
    //   },
    // },
    visibleProducts() {
      const products = this.$root.$data.state.products;

      // if ( this.selectedTag == 'view all' ) {
      //   return products;
      // }
      // Filter out courses by selected tags
      return products.filter(prod => prod.tags.map(tag => tag.toLowerCase()).indexOf(this.selectedTag) >= 0 );
    },
  },
  methods: {
    sendOrder() {
      this.$root.$data.sendOrder({ data: this.organizedData });
    },
    cancelOrder() {
      this.$root.$data.hideOrder();
    },
    compareTags(tag1, tag2) {
      let retValue = false;
      for(let i = 0; i < tag1.length; i++) {
        retValue = tag1[i].toLowerCase() == tag2.toLowerCase() ? true : retValue;
      }
      return retValue;
    },
    tagClicked(tag) {
      if(this.selectedTag !== tag.toLowerCase()) {
        this.selectedTag = tag.toLowerCase()
      } else {
        this.selectedTag = ''
      }
    },
  },
  watch: {
    personal: function (newState, oldState) {
      if (newState) this.commercial = false
    },
    commercial: function (newState, oldState) {
      if (newState) this.personal = false
    }
  }
};
</script>

<style scoped lang="stylus">

  @import '~@/styles/common.styl'

  .orders
    padding 40px 60px
    color #333
    box-sizing border-box
    +mobile()
      padding 45px 10px 10px
    h2
      text-align center
      margin-bottom 40px
      font-weight 600
      +mobile()
        margin-bottom 20px
    h3
      margin-bottom 25px
      font-weight 400
    .block-container
      display flex
      justify-content space-between
      +mobile()
        display block
    &__top-block
      position relative
      white-space nowrap
      padding-bottom 30px
      margin-bottom 40px
      width 48.5%
      display inline-block
      +mobile()
        white-space normal
        margin-bottom 10px
        width 100%
        padding-bottom 10px
    &__bottom-block
      display inline-block
      width 48.5%
      +mobile()
        width 100%
      .left-block,
      .right-block
        width 100%
    &__left-block,
    &__right-block
      white-space normal
      display inline-block
      vertical-align top
    &__left-block
      width 100%
      min-width 200px
      margin-right 15px
      +mobile()
        width 100%
        margin-bottom 20px
        // box-shadow 0px 0px 1px 2px #ccc
        overflow-y auto
        margin-right 0
      .tags
        max-height 420px
        overflow-y auto
        +mobile()
          max-height none
        .tag
          display block
          padding 15px
          text-align center
          font-size 16px
          line-height 16px
          border 1px solid #e4e4e4
          margin-bottom 10px
          text-transform capitalize
          cursor pointer
          position relative
          &:nth-last-child(1)
            margin-bottom 0px
          &.selected
            box-shadow inset 0px 0px 2px 1px $OTSred
            margin-bottom 0
            .tag__indicator
              &::after
                transform translate(-50%, -50%) rotate(225deg)
                margin-top 8px
          &__indicator
            position absolute
            color #fff
            width 46px
            height  46px
            background-color $OTSred
            top 0
            left  auto
            right 0
            &::after
              content ''
              border-width 1px 
              border-style solid 
              border-color #fff
              border-top none
              border-left none
              width 40%
              height 40%
              position absolute
              top 50%
              left 50%
              margin-top -2px
              transform translate(-50%, -50%) rotate(45deg)
              transition transform .3s ease-out
      .select-products
        max-height 420px
        overflow-y auto
        box-sizing border-box
        +mobile()
          max-height none
        &__product
          height auto
          margin 0px
          background #fff
          border 1px solid #e4e4e4
          border-top none
          display flex
          justify-content flex-start
          align-items center
          padding 6px 23px 6px 0
          &:last-of-type
            margin-bottom 10px
          input
            position relative
            appearance none
            margin 0px 13px
            height 30px
            width 30px
            border 1px solid #e4e4e4
            border-radius 8px
            vertical-align middle
            cursor pointer
            &:checked
              background $OTSred
              border 1px solid $OTSred
              &:before
                content ''
                position absolute
                height 100%
                width 100%
                left 0px
                top 0px
                background-image url('../assets/tick.png')
                background-repeat no-repeat
                background-position center
          label
            text-transform capitalize
            font-size 16px
            line-height 1.4
            font-weight 300
            vertical-align middle
            cursor pointer

    &__right-block
      position absolute
      height calc(100% - 30px)
      width 70%
      min-width 620px
      background-color #fff
      border 1px solid #e4e4e4
      +mobile()
        width 100%
        min-width 100%
        position relative
        overflow-y auto
      .select-products
        max-height 420px
        overflow-y auto
        &__product
          border-bottom 1px solid #e4e4e4
          height 42px
          margin 0px 2px
          input
            position relative
            appearance none
            margin 0px 13px
            height 30px
            width 30px
            border 1px solid #e4e4e4
            border-radius 8px
            vertical-align middle
            cursor pointer
            &:checked
              background $OTSred
              border 1px solid $OTSred
              &:before
                content ''
                position absolute
                height 100%
                width 100%
                left 0px
                top 0px
                background-image url('../assets/tick.png')
                background-repeat no-repeat
                background-position center
          label
            text-transform capitalize
            font-size 16px
            line-height 40px
            font-weight 300
            vertical-align middle
            cursor pointer

  .inputs
    .personal-commercial-holder
      display flex
      flex-wrap wrap
      align-items center
      justify-content space-between
      .personal,
      .commercial
        width 49%
        display flex
        justify-content flex-start
        align-items center
        font-size 15px
        +mobile()
          width 100%
    .gdpr
      label
        width 90%
    .personal,
    .commercial,
    .gdpr
      +mobile()
        width 100%
      label
        +mobile()
          width 75%
    .button
      padding 10px 20px
    .user-data
      width 100%
      margin-left 0
      margin-right 0
      &::placeholder 
        color #797979
        opacity 0.85
  .button
    &--try
      margin-left 0px
      margin-top 25px
      font-weight 300
      +mobile()
        width 100%
        margin 20px 0px
</style>



// WEBPACK FOOTER //
// src/components/MultipleOrders.vue